import { render, staticRenderFns } from "./DiscountSummary.vue?vue&type=template&id=332c48f8&scoped=true"
import script from "./DiscountSummary.vue?vue&type=script&lang=js"
export * from "./DiscountSummary.vue?vue&type=script&lang=js"
import style0 from "./DiscountSummary.vue?vue&type=style&index=0&id=332c48f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332c48f8",
  null
  
)

export default component.exports